import React from 'react';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import CabinetSchemaDimensions from './CabinetSchemaDimensions';
import styled from 'styled-components/macro';
import { RATIO_HEIGHT_PIXEL_TO_REAL_SIZE } from './constants';
import { Cabinet } from '../../lib/modelBuilder/entities/Cabinet';
// import styled from 'styled-components';

interface Props {
  item: Furniture | Cabinet;
}

const SchemaDimensions = ({ item }: Props) => (
  <FurnitureSchemaStyled
    heightFurniture={item.height}
    widthFurniture={item.width}
  >
    <div className="flex items-end">
      {item instanceof Furniture ? (
        item.cabinets.map(cabinetEntry => (
          <CabinetSchemaDimensions
            key={cabinetEntry.cabinet.id}
            cabinet={cabinetEntry.cabinet}
          />
        ))
      ) : (
        <CabinetSchemaDimensions cabinet={item} />
      )}
    </div>
  </FurnitureSchemaStyled>
);

const FurnitureSchemaStyled = styled.div<{
  heightFurniture: number;
  widthFurniture: number;
}>`
  width: max(
    ${p => Math.round(p.widthFurniture * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE)}px,
    100%
  );
  height: max(
    ${p => Math.round(p.heightFurniture * RATIO_HEIGHT_PIXEL_TO_REAL_SIZE)}px,
    98%
  );
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: white;
`;

export default SchemaDimensions;
